import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '../ui/table';
import { formatUKDateTime, getElapsedLabel } from '../../utils/attendanceDateTime';
import AttendanceStatusBadge from './AttendanceStatusBadge';

export default function LiveAttendanceTable({ rows }) {
  if (rows.length === 0) {
    return (
      <div className="card-rtb">
        <p className="text-[#A1A1AA]">No staff are currently clocked in for this filter.</p>
      </div>
    );
  }

  return (
    <div className="card-rtb overflow-x-auto" data-testid="live-attendance-table">
      <Table>
        <TableHeader>
          <TableRow className="border-[#3F3F46]">
            <TableHead>Staff</TableHead>
            <TableHead>Role</TableHead>
            <TableHead>Venue</TableHead>
            <TableHead>Clock In</TableHead>
            <TableHead>Elapsed</TableHead>
            <TableHead>Break</TableHead>
            <TableHead>Source</TableHead>
            <TableHead>Notes</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {rows.map((row) => (
            <TableRow key={row.time_entry_id} className="border-[#27272A]">
              <TableCell className="text-white font-medium">{row.staff_name}</TableCell>
              <TableCell className="text-[#A1A1AA] uppercase">{row.role}</TableCell>
              <TableCell className="text-[#E4E4E7]">{row.venue_name}</TableCell>
              <TableCell className="text-[#E4E4E7]">{formatUKDateTime(row.clock_in_at)}</TableCell>
              <TableCell className="text-[#E4E4E7] font-mono">{getElapsedLabel(row.clock_in_at)}</TableCell>
              <TableCell>
                <AttendanceStatusBadge status={row.on_break ? 'on_break' : 'clocked_in'} />
              </TableCell>
              <TableCell className="text-[#E4E4E7]">{row.source || '-'}</TableCell>
              <TableCell className="text-[#A1A1AA]">{row.notes || '-'}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}
